module.exports = __webpack_public_path__ + "media/dogs/dog-weight-31d30a63.svg";